import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
  document: null,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@auth/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.signed = true;
        draft.loading = false;
        break;
      }
      case '@auth/SIGN_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.token = null;
        draft.signed = false;
        draft.loading = false;
        break;
      }
      case '@auth/AUTH_DOCUMENT_REQUEST': {
        draft.loading = true;
        draft.document = action.payload.document;
        break;
      }
      case '@auth/AUTH_DOCUMENT': {
        draft.loading = false;
        draft.document = action.payload.document;
        break;
      }
      case '@auth/FORGET_PASSWORD_REQUEST': {
        draft.loading = true;
        draft.document = action.payload.document;
        break;
      }
      case '@auth/FORGET_PASSWORD': {
        draft.loading = false;
        draft.document = action.payload.document;
        break;
      }
      default:
        draft.loading = false;
    }
  });
}
